module.exports = __webpack_public_path__ + "img/background.2714ce9d.png";